import { Item } from '../types/Item';

export const items: Item[] = [
    { date: new Date(2022, 9, 6), category: 'comida', title: 'McDonalds', value: 32.12 },
    { date: new Date(2022, 9, 15), category: 'comida', title: 'Burger King', value: 28 },
    { date: new Date(2022, 9, 16), category: 'moradia', title: 'Aluguel Apt', value: 2300 },
    { date: new Date(2022, 10, 18), category: 'salario', title: 'Salário ACME', value: 4500 },
];